var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6201_105599",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6201_105599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0031 14.5161L9.86146 17.6578C9.66285 17.8564 9.41007 17.9557 9.10312 17.9557C8.79618 17.9557 8.5434 17.8564 8.34479 17.6578C8.14618 17.4592 8.04688 17.2064 8.04688 16.8995C8.04688 16.5925 8.14618 16.3398 8.34479 16.1411L11.4865 12.9995L8.34479 9.8849C8.14618 9.68628 8.04688 9.43351 8.04688 9.12656C8.04688 8.81962 8.14618 8.56684 8.34479 8.36823C8.5434 8.16962 8.79618 8.07031 9.10312 8.07031C9.41007 8.07031 9.66285 8.16962 9.86146 8.36823L13.0031 11.5099L16.1177 8.36823C16.3163 8.16962 16.5691 8.07031 16.876 8.07031C17.183 8.07031 17.4358 8.16962 17.6344 8.36823C17.851 8.5849 17.9594 8.84219 17.9594 9.1401C17.9594 9.43802 17.851 9.68628 17.6344 9.8849L14.4927 12.9995L17.6344 16.1411C17.833 16.3398 17.9323 16.5925 17.9323 16.8995C17.9323 17.2064 17.833 17.4592 17.6344 17.6578C17.4177 17.8745 17.1604 17.9828 16.8625 17.9828C16.5646 17.9828 16.3163 17.8745 16.1177 17.6578L13.0031 14.5161Z",
    fill: "#A7B4C1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.5b6b030a4226b0fcf98b482d5c36d557.svg";
export { ForwardRef as ReactComponent };